import React, { useState } from "react"
import {
  Container,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  Skeleton
} from "@mui/material"
import { Visibility, VisibilityOff } from "@mui/icons-material"
import { useLoginMutation } from "../../features/user/authApi"
import { useDispatch } from "react-redux"
import { setCredentials } from "../../features/user/authSlice"
import { useNavigate } from "react-router-dom"

const Login = () => {
  const [showPassword, setShowPassword] = useState(false)
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    remember: false
  })
  const [login, { isLoading,isError }] = useLoginMutation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleChange = e => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    try {
      const res = await login({
        email: formData.email,
        password: formData.password
      }).unwrap()
      dispatch(setCredentials({ token: res.data.token, user: res.data }))
      navigate("/dashboard")
    } catch (err) {
      console.error("Login failed:", err)
    }
  }

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: 3,
          border: "1px solid #ccc",
          borderRadius: 2,
          boxShadow: 3,
          background: "white"
        }}
      >
        <Typography component="h1" variant="h5" color="primary" mb={2}>
          Sign In
        </Typography>

        {/* <Alert severity="info" sx={{ mb: 2, color: 'secondary.main',
           '& .MuiAlert-icon': {
                 color: 'primary.main',
            }, 
        }}>
          Please login with your credentials
        </Alert> */}

        {isLoading ? (
          <>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={56}
              sx={{ mb: 2, borderRadius: 1 }}
            />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={56}
              sx={{ mb: 2, borderRadius: 1 }}
            />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{ borderRadius: 1 }}
            />
          </>
        ) : (
          <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
            <TextField
              margin="normal"
              fullWidth
              required
              label="Email Address"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
            />

            <TextField
              margin="normal"
              fullWidth
              required
              name="password"
              label="Password"
              type={showPassword ? "text" : "password"}
              value={formData.password}
              onChange={handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(prev => !prev)}
                      edge="end"
                    >
                      {showPassword ? (
                        <VisibilityOff sx={{ color: "secondary.main" }} />
                      ) : (
                        <Visibility sx={{ color: "secondary.main" }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.remember}
                  onChange={handleChange}
                  name="remember"
                  color="secondary"
                />
              }
              label="Remember me"
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 2, mb: 2 }}
              disabled={isLoading}
            >
              Login
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  )
}

export default Login
